module.exports = __webpack_public_path__ + "img/story-header@2x.3d77d863.jpg";